/**
 * Partition the combined my-partial-sales listings into the two IA groups the
 * page renders as separate sections:
 *   - owned:      listings the current user owns (seller)       → "My Listings"
 *   - interested: listings the user expressed interest in (buyer) → "Listings I'm Interested In"
 *
 * The controller (succession_controller#partial_sales) already builds these two
 * sets separately and they are disjoint — `interested_listings` excludes the
 * user's own listings — so a listing can never land in both groups here. The
 * partition key mirrors the component's existing `listing.user.id === user.id`
 * ownership check.
 *
 * @param {Array} listings - the combined `partialSales` array
 * @param {number|string} currentUserId - the viewer's user id
 * @returns {{ owned: Array, interested: Array }}
 */
export const splitMyPartialSales = (listings, currentUserId) => {
  const owned = [];
  const interested = [];

  (listings || []).forEach((listing) => {
    // eslint-disable-next-line eqeqeq
    if (listing && listing.user && listing.user.id == currentUserId) {
      owned.push(listing);
    } else {
      interested.push(listing);
    }
  });

  return { owned, interested };
};

export default splitMyPartialSales;
